<template>
    <div
        class="cabinet-table__row flex flex-column flex-lg-row align-items-lg-center pt-4 pb-4"
    >
        <div class="catalog-garnitures__cell">
            Гарнитур {{ garniture.set_article }}
            <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
                <div
                    class="cabinet__catalog-tag cabinet__catalog-tag--uppercase"
                >
                    <a>
                        {{ garniture.brand.BrandName }}
                    </a>
                </div>
                <div v-if="material" class="cabinet__catalog-tag">
                    <a>{{ material }}</a>
                </div>
                <div v-if="fineness" class="cabinet__catalog-tag">
                    <a>{{ fineness }}</a>
                </div>
                <div
                    v-for="(insertMaterial, i) in insertMaterials"
                    :key="i"
                    class="cabinet__catalog-tag"
                >
                    <a>{{ insertMaterial }}</a>
                </div>
            </div>
        </div>
        <div class="catalog-garnitures__right">
            <router-link
                v-for="item in garniture.items"
                :key="item.ItemID"
                :to="{
                    name: 'RetailerCatalogProductID',
                    params: {
                        id: item.ItemID
                    }
                }"
                target="_blank"
                class="catalog-garnitures__img-wrap"
            >
                <img
                    class="catalog-garnitures__img ofi"
                    :src="item.images.length ? item.images[0].url : null"
                />
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RetailerCatalogGarnituresItem',
    props: {
        garniture: {
            type: Object,
            required: true
        }
    },
    computed: {
        material() {
            let materialsArr = this.garniture.items.map(item =>
                item.materials.length ? item.materials[0].Name : ''
            )
            let materialsArrUnique = materialsArr.filter(
                (v, i, a) => a.indexOf(v) === i
            )
            return materialsArrUnique.length === 1 ? materialsArrUnique[0] : ''
        },
        fineness() {
            let finenessArr = this.garniture.items.map(item =>
                item.materials.length ? item.materials[0].pivot.Fineness : ''
            )
            let finenessArrUnique = finenessArr.filter(
                (v, i, a) => a.indexOf(v) === i
            )
            return finenessArrUnique.length === 1 ? finenessArrUnique[0] : ''
        },
        insertMaterials() {
            let insertMaterialsArr = []
            this.garniture.items.forEach(item => {
                if (item.inserts.length) {
                    let materials = item.inserts.map(
                        insert => insert.material.Name
                    )
                    insertMaterialsArr.push(materials)
                }
            })

            let result = []
            if (insertMaterialsArr.length) {
                //Finding matches
                result = insertMaterialsArr.shift().filter(function(v) {
                    return insertMaterialsArr.every(function(a) {
                        return a.indexOf(v) !== -1
                    })
                })
            }

            return result
        }
    }
}
</script>
